import React, { useEffect, useState } from 'react';
import "./Printpage.css";
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import apf_logo from '../../../../images/auth/apf_logo_full.png';

const MenuMakerPrint = () => {
  const branch_id = parseInt(localStorage.getItem("branch_id"), 10);
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const product_id = params.get("product_id"); // ✅ Required
  const productcategory_id = params.get("productcategory_id"); // Optional
  const month = parseInt(params.get("month")); // ✅ Required
  const year = parseInt(params.get("year"));   // ✅ Required

  const [menuData, setMenuData] = useState([]);
  const [categoryName, setCategoryName] = useState('');

  const getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { weekday: 'long' });
  };

  const getWeekNumber = (dateStr) => {
    const d = new Date(dateStr);
    const start = new Date(d.getFullYear(), d.getMonth(), 1);
    const diff = d.getDate() + start.getDay() - 1;
    return Math.floor(diff / 7) + 1;
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric'
    });
  };

  const monthLabel = new Date(year, month - 1, 1).toLocaleString("default", {
    month: "long", year: "numeric"
  });

  useEffect(() => {
    if (!product_id || !month || !year) return;

    // Get category name
    if (productcategory_id) {
      axios.get(`${baseURL}/products/grouped-by-product-item-category`)
        .then(res => {
          const category = (res.data.data || []).find(cat =>
            String(cat.product_category_id) === productcategory_id
          );
          if (category) setCategoryName(category.product_category_name);
        });
    }

    // Get menu data
    axios.get(`${baseURL}/menumaker`, {
      params: {
        product_id,
        productcategory_id,
        month,
        year,
        branch_id
      }
    }).then(res => {
      const grouped = {};

      (res.data.data || []).forEach(entry => {
        let items = [];
        try {
          items = typeof entry.menumaker_item === 'string'
            ? JSON.parse(entry.menumaker_item)
            : entry.menumaker_item;
          if (!Array.isArray(items)) items = [];
        } catch {
          items = [];
        }

        const week = getWeekNumber(entry.menumaker_date);
        if (!grouped[week]) grouped[week] = [];
        grouped[week].push({
          date: entry.menumaker_date,
          items
        });
      });

      setMenuData(grouped);
    });
  }, [product_id, productcategory_id, month, year, baseURL]);

  return (
    <div className='page_print'>
      <div className='fs-2 text-black text-center'>
        <label>{categoryName}</label>
      </div>

      <div className="row mt-2">
        <div className="col-lg-12 d-flex align-items-center justify-content-between mb-3">
          <div>
            <img src={apf_logo} alt="Logo" className="w-250px h-50px ms-0" />
          </div>
          <div className='text-black fs-6'>
            <div>
              <i className="fa-regular fa-calendar me-3" /> {monthLabel}
            </div>
            <div className='text-danger font-w600 mt-2 fs-6'>APF/{year}/MENU</div>
          </div>
        </div>

        <div className='border-bottom'></div>

        {Object.entries(menuData).sort().map(([weekNum, days]) => (
          <div key={weekNum} className="col-lg-12 mb-4 mt-3">
            <div className='text-danger text-center font-w600 fs-3'>Week - {weekNum}</div>
            <table className="table align-middle table-striped fs-7 gy-1 gs-2 dataTable mb-5">
              <thead>
                <tr className="text-start fw-bold fs-6 gs-0 bg-primary">
                  <th className='min-w-50px text-start text-white'>Date</th>
                  <th className='min-w-100px text-white'>Day</th>
                  <th className='min-w-100px text-white'>Item Count</th>
                  <th className='min-w-100px text-white'>Items</th>
                </tr>
              </thead>
              <tbody className="text-gray-600 fw-semibold fs-7">
                {days.map(({ date, items }, idx) => (
                  <tr key={idx}>
                    <td className='text-start'>
                      <label className='text-black font-w400 fs-7'>{formatDate(date)}</label>
                    </td>
                    <td className='text-start'>
                      <label className='text-black font-w400 fs-7'>{getDayName(date)}</label>
                    </td>
                    <td className='text-start'>
                      <label className='text-black font-w400 fs-7'>{items.length}</label>
                    </td>
                    <td className='text-start'>
                      <div className='text-black font-w400 fs-7 mw-300px text-wrap'>
                        {items.map(i => i.item_name).join(', ')}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuMakerPrint;
